<template>
  <div :class="pageClass">
    <div class="right">
      <div class="list">
        <div class="introduce-tab">
          <ul>
            <li>错题本</li>
          </ul>
        </div>
        <div class="content">
          <ul v-if="list.length" class="content-list" v-loading="countLoading">
            <li v-for="(topic, index) in list" :key="index" @click="goRedotest(2, topic, index, params.pageIndex)">
              <div class="order">{{ index + (params.pageIndex - 1) * 5 + 1 >= 10 ? index + (params.pageIndex - 1) * 5 + 1 : `0${index + (params.pageIndex-1) * 5 + 1 }` }}</div>
              <div class="name">
                <template v-if="topic.parentTypeId != null && topic.parentTypeId == 19">
                  <div class="p-name" v-html="`完形填空-第${topic.originalName}题`"></div>
                </template>
                <template v-else-if="topic.parentTypeId != null && (topic.parentTypeId == 210 || topic.parentTypeId == 214 || topic.parentTypeId == 223)">
                  <div class="p-name" v-html="`听力-第${topic.originalName}题`"></div>
                </template>
                <template v-else-if="topic.parentTypeId != null && topic.parentTypeId == 20">
                  <div class="p-name" v-html="`阅读理解-第${topic.originalName}题`"></div>
                </template>
                <div v-else class="p-name" v-html="tirmDiv(topic.stem, topic.originalName, topic.parentOriginalName)"></div>
              </div>
              <div class="time">
                <div class="p-name">考试时间</div>
                <div class="p-title">{{ new Date(topic.createTime).format('yyyy/MM/dd hh:mm:ss') }}</div>
              </div>
              <div class="type">{{ topic.name }}</div>
            </li>
          </ul>
          <div class="nocountent" v-else>
            <img src="../../../assets/images/home/nocountent.jpg" alt="">
            <p>暂无数据~</p>
          </div>
          <topic-page
            @currentChange="currentIndexPaperChild"
            :page-index="params.pageIndex"
            :total-count="total"
            :page-size="params.pageSize"
          ></topic-page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import topicPage from "@/components/page/index";
import childPaper from '@/components/paper/child_paper/child_paper';

export default {
  data() {
    return {
      pageClass: 'wrongTopic',
      countLoading: true,
      navActive: 9,
      params: {
        userId: null,
        subjectId: null, // 学科id
        pageSize: 5,
        pageIndex: 1,
        paperId: null
      },
      total: 0,
      list: [],
      appId: 100
    }
  },
  components: {
    topicPage
  },
  methods: {
    // 获取试卷信息
    getPageDataUncorrection() {
      this.countLoading = true
      this.$HTTP.executePost(this.$APIS.GET_WRONG_BOOK_UNCORRECTION, this.params, this).then(res => {
          let code = res.code;
          if (!code) {
            this.list = res.data.list
            this.total = res.data.total
            this.params.pageIndex = res.data.pageIndex
            this.params.pageSize = res.data.pageSize
            this.countLoading = false
          } else {
            this.countLoading = false
            this.$message.error(res.msg);
          }
      })
    },
    goRedotest(type, topic, index, page) {
      let that = this
      this.$router.push({
        path: '/client_wrong_detail',
        query: {
          type: type,
          question_id: topic.questionId,
          paper_id: topic.paperId,
          subject_id: topic.subjectId,
          knowledge_point_id: topic.knowledgePointId || null,
          type_id: topic.typeId || null,
          exam_id: topic.examId,
          index: index, // 当前页的第几个
          page: page,
          app_id: this.appId
        }
      })
    },
    // 试卷列表下的二级分页器
    currentIndexPaperChild(ind) {
      this.params.pageIndex = ind
      this.getPageDataUncorrection()
    },
    tirmDiv(tips, name, pantentName) {
      let str4 = tips.trimHeadTailTag("body").trimHeadTailTag("div");
      let reg1 = /<span[^>]*(?:\/>|>(?:&#xa0;)*<\/span>)/  // 去除空span
      let noPdom = str4.replace(reg1, '');
      let reg2 = /<p[^>]*(?:\/>|>(?:\s|&nbsp;)*<\/p>)/ // 去除空p
      let Pdom = noPdom.replace(reg2, '')
      let res3 = /^<p[^>]*>(((?!<\/p >).)*)<\/p>/ // 去除两头p
      let values = Pdom.replace(res3, '$1')
      let reg = /font-size:\d+\.?\d*pt/g
      let str = values.replace(reg, `font-size:22px`)
      let res4 = /font-size:(\d+\.?\d*?)px;([^<>]*?)vertical-align:sub;?/g
      let subValue = str.replace(res4, 'font-size:14px;$2vertical-align:sub;')
      let res5 = /font-size:(\d+\.?\d*?)px;([^<>]*?)vertical-align:super;?/g
      let supValue = subValue.replace(res5, 'font-size:14px;$2vertical-align:super;')
      let str3 = supValue
      if (this.navActive == 10 ||　this.navActive == 12) {
        if(pantentName && str3) {
          return `${pantentName}.${str3}`
        } else if (name && str3) {
          return `${name}.${str3}`
        } else {
          return str3
        }
      } else {
        return `${name}.${str3}`
      }
    }
  },
  created() {
    this.appId = +this.$route.query.app_id || 100
    this.countLoading = true
    let user_json = localStorage.getItem('userinfo');
    const user = JSON.parse(user_json);
    this.navActive = this.$route.query.subject_id ? this.$route.query.subject_id : this.navActive
    this.params.userId = user.id
    this.params.subjectId = +this.$route.query.subject_id
    this.params.paperId = +this.$route.query.pid

    setTimeout(() => {
      this.getPageDataUncorrection()
    }, 2000)

    this.getPageDataUncorrection()
  }
}
</script>
<style scoped lang="stylus"> // scss stylus
  .nocountent {
    width: 400px;
    margin: 0 auto;
    margin-top: 50px;
    position: relative;
    img {
      width: 100%;
    }
    p {
      color: #a9a9a9;
      font-size: 18px;
      width: 100%;
      position: absolute;
      bottom: 5px;
      text-align: right;
      padding-right: 40px;
    }
  }
  .wrongTopic {
    width: 1520px;
    height: 100%;
    margin: 0 auto;
    padding: 10px auto;
    position: relative;
    .left {
      position: absolute;
      width: 133px;
      top: 28px;
      bottom: 40px;
      background-color: #fff;

      li {
        height: 60px;
        color: #333333;
        font-size: 20px;
        line-height: 60px;
        text-align: center;
        cursor: pointer;
      }
      li:hover {
        color: #fff;
        background-color:  #5c307f;
      }

      .active {
        color: #fff;
        background-color:  #5c307f;
      }
    }
    .right {
      width: 100%;
      height: 100%;
      padding-left: 135px;

      .list {
        position: absolute;
        top: 28px;
        left: 150px;
        bottom: 40px;
        right: 0px;
        background-color: #fff;

        .introduce-tab {
          padding-top: 22px;
          width: 100%;
          font-size: 21px;

          ul {
            height: 44px;
            border-bottom: 1px solid #c7c7c7;
            width: 100%;

            li {
              float: left;
              width: 100px;
              text-align: center;
              margin-left: 45px;
              line-height: 40px;
              color: #5a5a5a;
            }

            li:hover {
              border-bottom: 4px solid #5c307d;
              box-sizing: border-box;
              cursor: pointer;
            }

            .active {
              border-bottom: 4px solid #5c307d;
              box-sizing: border-box;
            }
          }
        }

        .content {
          .content-list {
            li {
              height: 110px;
              cursor: pointer;
              .order {
                width: 60px;
                height: 60px;
                border: 1px solid #cd99fe;
                border-radius: 8px;
                color: #5a3376;
                background-color: #f8edfe;
                float: left;
                margin-top: 23px;
                margin-left: 53px;
                text-align: center;
                line-height: 60px;
                font-size: 16px;
              }
              .name {
                width: 470px;
                height: 60px;
                float: left;
                margin-left: 20px;
                margin-top: 24px;
                overflow: hidden;
                .p-name {
                  font-size: 22px;
                  color: #3f3f3f;
                  width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  height: 40px;
                  line-height: 40px;

                  /deep/ img {
                    vertical-align: middle !important;
                    display: inline-block;
                    height: 40px !important;
                    width: auto !important;
                  }
                }
                .p-title {
                  font-size: 16px;
                  color: #a6a6a6;
                  width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  line-height: 20px;
                }
              }

              .name-line {
                .p-name {
                  line-height: 40px;
                  /deep/ img {
                    vertical-align: middle !important;
                    display: inline-block;
                  }
                }
              }

              .time {
                width: 250px;
                height: 60px;
                float: left;
                margin-left: 100px;
                margin-top: 23px;
                .p-name {
                  font-size: 18px;
                  color: #a6a6a6;
                  width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  /deep/ img {
                    vertical-align: middle !important;
                    display: inline-block;
                  }
                }
                .p-title {
                  font-size: 18px;
                  color: #a6a6a6;
                  width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-top: 12px;
                }
              }
              .type {
                width: 120px;
                height: 110px;
                color: #a6a6a6;
                font-size: 18px;
                line-height: 110px;
                float: left;
                margin-left: 120px;
              }

              .back {
                width: 100px;
                border: 1px solid #aaa;
                border-radius: 4px;
                height: 44px;
                line-height: 44px;
                text-align: center;
                float: right;
                margin-top: 25px;
                color: #aaa;
                margin-right: 50px;
                font-size: 16px;
                cursor: pointer;
              }

              .back:hover {
                color: #5c307f;
                border-color: #5c307f;
              }

            }

            .tops {
              height: 65px;
            }
            
          }
        }
      }
    }

    .el-tabs--border-card {
      background: none;
      border: none;
      box-shadow: none;
    }
    /deep/ .el-tabs {
      width: 100%;
      height: 100%;
      // position: relative;
      .el-tabs--border-card {
        border: none;
        box-shadow: none;
      }
      .el-tabs__item {
        font-size 18px;
        padding: 0 95px !impontent;
        color: #5c307d;
        height: 50px;
        line-height: 50px;
      }
      .el-tabs__item:last-child {
        padding: 0 95px;
      }
      .el-tabs__item:first-child {
        padding: 0 95px;
      }
      .el-tabs__item:nth-child(2) {
        padding: 0 95px;
      }
      .el-tabs__nav-wrap::after {
        background-color: #ffffff;
      }
      .el-tabs__item.is-active {
        color: #ffffff;
        background-color: #5c307d;
      }
      .el-tabs__header {
        border-bottom 1px solid #5c307d;
      }
      .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
        color: #ffffff;
        background-color: #5c307d;
      }

      .el-tabs__content {
        padding: 0;
      }
    }
  }
</style>